import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Col,
  Button,
  Image,
  Input,
  Upload,
  Row,
  Modal,
  Tooltip,
  Radio,
  Space,
  Skeleton,
} from "antd";

import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import update from "immutability-helper";
import {
  getOurCulturePhotos,
  updateCompanyProfileDetails,
  resetCompanyProfileDetails,
  getCompanyProfileDetails,
} from "../../../redux/actions";
import {
  PlusOutlined,
  SearchOutlined,
  ArrowLeftOutlined,
  CheckCircleFilled,
  LoadingOutlined,
  ExclamationCircleOutlined
} from "@ant-design/icons";
import { HiPlus } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { getImage } from "../../../utilities/storageOperations/downloadURL";
import { fetchToken, getCompanyProfileDetailsApi } from "../../../API/API";
import axios from "axios";
import history from "../../../routes/history";
import MediaQuery from "react-responsive";
import ImgCrop from "antd-img-crop";
import "./marquee.css";
import TopAlert from "../../../components/TopNotification/TopAlert";
import { FaBullseye } from "react-icons/fa";
import Uploadbanner from "../../Conversations/components/ChatCard/components/Uploadbanner/Uploadbanner";

const type = "DragableUploadList";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const DragableUploadListItem = ({ originNode, moveRow, file, fileList }) => {
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;
  const ref = React.useRef();
  const index = fileList.indexOf(file);
  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: type,
    collect: (monitor) => {
      const { index: dragIndex } = monitor.getItem() || {};
      if (dragIndex === index) {
        return {};
      }
      return {
        isOver: monitor.isOver(),
        dropClassName:
          dragIndex < index ? " drop-over-downward" : " drop-over-upward",
      };
    },
    drop: (item) => {
      moveRow(item.index, index);
    },
  });
  const [, drag] = useDrag({
    type,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  drop(drag(ref));
  const errorNode = (
    <Tooltip title="Upload Error">{originNode.props.children ?? null}</Tooltip>
  );
  return (
    <div
      ref={ref}
      className={`ant-upload-draggable-list-item ${
        isOver ? dropClassName : ""
      }`}
      style={{ cursor: "move" }}
    >
      {file.status === "error" ? errorNode : originNode}
    </div>
  );
};

const MarqueeAlbum = () => {
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;
  const dispatch = useDispatch();
  const photos = useSelector((state) => state.getCulturePhotos.photos);
  const photosLoading = useSelector((state) => state.getCulturePhotos.loading);
  const [loading, setLoading] = useState(false);
  const [alertDisplay, setAlertDisplay] = useState("none");
  const [MarqueePictureId, setPrimaryPhoto] = useState();
  const [dimensions, setDimensions] = useState(window.innerWidth);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [markedPrimary, setMarkedPrimary] = useState(false);
  const [fileSizeCheck, setFileSizeCheck] = useState(false);
  const [fileTypeCheck, setFileTypeCheck] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const resp = useSelector(
    (state) => state.getCompanyProfileDetailsReducer.resp
  );

  useEffect(() => {
    setDimensions(window.innerWidth);
  }, [window.innerWidth]);

  const modalStyle = {
    display: alertDisplay,
    position: "fixed",
    width: "100%",
    height: "50px",
    left: "0",
    color: "#fff",
    zIndex: "2000",
    top: "0",
    margin: "auto",
  };
  const closeAlert = () => {
    setAlertDisplay("none");
  };

  const [fileList, setFileList] = useState([]);
  const [fileList2, setFileList2] = useState([]);

  useEffect(() => {
    dispatch(resetCompanyProfileDetails());
    dispatch(getOurCulturePhotos("MARQE"));
  }, [fileList]);

  useEffect(async () => {
    if (photos.length && photos[0]?.Album_Pictures) {
      const list = [];
      for (var i = 0; i < photos[0].Album_Pictures.length; ++i) {
        list.push({
          url: `${process.env.REACT_APP_S3_URL}/content/pics/albums/thumbs/${photos[0].Album_Pictures[i].Filename}`,
          s3key: `${process.env.REACT_APP_S3_URL}/content/pics/albums/thumbs/${photos[0].Album_Pictures[i].Filename}`,
        });
      }
      setFileList2(list);
    }
  }, [photos]);

  const moveRow = useCallback(
    (dragIndex, hoverIndex) => {
      const dragRow = fileList[dragIndex];
      setFileList(
        update(fileList, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragRow],
          ],
        })
      );
    },
    [fileList]
  );

  const onChange = ({ fileList: newFileList }) => {
    // Ensure only one image is present
    if (newFileList.length > 1) {
      newFileList = [newFileList[newFileList.length - 1]]; // Keep only the latest image
    }
    setFileList(newFileList);
    setFileList2(newFileList);
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  const onRemove = async (file) => {
    const headers = await fetchToken();
    const filepath = file.s3key.split(".com/")[1];
    const removeUrl = `${BackendApiBaseUrl}/empprofile/albums/delete/MARQE`;
    const payload = {
      Filename: filepath.split("/")[4],
    };
    try {
      const response = await axios.put(removeUrl, payload, { headers });
      if (response.status == 200) {
        setDeleteSuccess(true);
        setTimeout(() => {
          setDeleteSuccess(false);
        }, 3000);
      }
    } catch (error) {
    }
  };

  const uploadImage = async (file) => {
    setFileSizeCheck(false);
    setFileTypeCheck(false);
    setLoading(true);
    const headers = await fetchToken();
    if (
        (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) || 
        file.name.toLowerCase().endsWith(".jfif") 
    ) {
        setFileTypeCheck(true);
        setLoading(false);
    } else if (file.size > 10000000) {
        setFileSizeCheck(true);
        setLoading(false);
    } else {
        if (fileList2.length > 0) {
            const existingFile = fileList2[0];
            await onRemove(existingFile);
        }

        const payload = {
            type: "albums",
            contentType: file.type,
            albums: true,
        };
        const imageUrl = `${BackendApiBaseUrl}/upload`;
        const data = await axios.post(imageUrl, payload, { headers });
        const response = data.data;
        const uploadRequestS3 = await axios.put(response.uploadURL, file);

        const body = {
            Pictures: [
                {
                    Filename: response.Key.split("/")[4],
                    FileSize: file.size,
                },
            ],
        };
        const uploadRequest = await axios.put(
            `${BackendApiBaseUrl}/empprofile/albums/update/MARQE`,
            body,
            { headers }
        );
        if (uploadRequest.status == 200) {
            setPrimaryPhoto(response.Key.split("/")[4]);
            setUploadSuccess(true);
            setLoading(false);
            setTimeout(() => {
                setUploadSuccess(false);
            }, 3000);
        } else {
            setLoading(false);
        }
    }
};

  useEffect(() => {
    dispatch(getCompanyProfileDetails());
  }, []);

  const [value, setValue] = React.useState(1);
  const [radioButton, setRadioButton] = useState(1);
  let x = 1;

  useEffect(() => {
    if(fileList2?.length!=1){
      if(resp?.companyProfile?.MarqueePictureId!=null){
        setPrimaryPhoto(resp?.companyProfile?.MarqueePictureId);
      }
    }
  }, [resp]);

  useEffect(() => {
    if (fileList2?.length == 1) {
      if (fileList2[0]?.s3key?.split("thumbs/")[1] !== null) {
        setPrimaryPhoto(fileList2[0]?.s3key?.split("thumbs/")[1]);
        dispatch(
          updateCompanyProfileDetails({
            MarqueePictureId: fileList2[0]?.s3key?.split("thumbs/")[1],
          })
        );
      }
    }
  }, [fileList2]);

  const onChangeRadio = (e) => {
    setMarkedPrimary(true);
    setPrimaryPhoto(e.target.value.s3key?.split("thumbs/")[1]);
    setValue(radioButton);
    setRadioButton(radioButton + 1);
    x = x + 1;
  };

  useEffect(() => {
    if (MarqueePictureId && markedPrimary) {
      dispatch(updateCompanyProfileDetails({ MarqueePictureId }));
      dispatch(getOurCulturePhotos("MARQE"));
      setAlertDisplay("block");
      setTimeout(() => {
        setAlertDisplay("none");
        setMarkedPrimary(false);
      }, 3000);
    }
  }, [MarqueePictureId]);

  const goback = () => {
    dispatch(resetCompanyProfileDetails());
    history.goBack();
  };

  const handleBeforeUpload = (file) => {
    return new Promise((resolve, reject) => {
      setFileTypeCheck(false);
      setFileSizeCheck(false);
      const isImage = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isImage) {
        setFileTypeCheck(true);
        setTimeout(() => setFileTypeCheck(false), 3000); 
        reject(new Error('You can only upload JPEG, JPG, PNG formats!'));
      } else if (!isLt10M) {
        setFileSizeCheck(true);
        setTimeout(() => setFileSizeCheck(false), 3000); 
        reject(new Error('Image must be smaller than 10MB!'));
      } else {
        const reader = new FileReader();
        reader.onload = (event) => {
          let image = document.createElement('img');
          image.src = event.target.result;
          console.log(event.target.result,'event.target.result')
  
          image.onload = () => {
            resolve(file);
          };
  
          image.onerror = () => {
            reject(new Error('Invalid image file'));
            setFileTypeCheck(true);
            setTimeout(() => setFileTypeCheck(false), 3000); 
          };
        };
  
        reader.readAsDataURL(file);
      }
    });
  };
  return (
    <div className="Marquee-mainbg">
      {
        fileTypeCheck?
        (
          <TopAlert
            display={"flex"}
            title={
              <>
                <ExclamationCircleOutlined style={{ marginRight: 8 }} />
                File format not supported
              </>
            }
            type="warning"
          />
        ) : null
      }
      {
        fileSizeCheck?
        (
          <TopAlert
            display={"flex"}
            title={"File format not supported"}
            type="warning"
          />
        ) : null
      }
      {uploadSuccess ? (
        <TopAlert
          display={"flex"}
          title={"Company banner successfully saved"}
          type="success"
        />
      ) : null}
      {deleteSuccess ? (
        <TopAlert
          display={"flex"}
          title={"Banner successfully removed"}
          type="success"
        />
      ) : null}
      <Col lg={23} md={23} sm={23} xs={24}>
        <div className="modal" style={modalStyle}>
          <div className="modal-content">
            <Row style={{ marginTop: "10px" }}>
              <div className={"alert-msg"}>
                <CheckCircleFilled style={{ paddingRight: "5px" }} />
                Company banner successfully saved
              </div>
              <div className="close" onClick={closeAlert}>
                &times;
              </div>
            </Row>
          </div>
        </div>
        <div className="container1">
          <div style={{ padding: "10px" }}> </div>
          <div className="top">
            <ArrowLeftOutlined className="crossStyle" onClick={goback} />
            <div className="panel1">
            </div>
          </div>
          <div style={{  display:'flex', justifyContent:'center',marginBottom: fileList2?.length === 0 ? "70px" : "69px", }}>
            <div
              className={
                fileList2?.length == 0 && windowDimensions.width > 769
                  ? "Marquee-empty-div"
                  : "Marquee-subcont"
              }
              style={{
                background: "#ffffff",
                border: windowDimensions.width > 769 ? "1px solid #d4d4d4" : "none", // Desktop par full border
                borderTop: windowDimensions.width <= 769 ? "1px solid #d4d4d4" :'1px solid #d4d4d4', // Mobile par sirf border-top
                marginBottom: "30px",
              }}
            >
              <div className="Marquee-alb">Add a company banner </div>
              <div className="Marquee-desc">
                Add pictures that represent your company. Select one picture to
                be displayed as the company banner
              </div>
              {photosLoading ? (
                <div
                  className="ShimmerDiv"
                  style={{
                    margin: "auto",
                    marginTop: "10%",
                    marginBottom: "25%",
                  }}
                >
                  <Skeleton.Image active />
                </div>
              ) : (
                <Col lg={24} md={24} sm={24} xs={24}>
                  <div className="down">
                    <Radio.Group onChange={onChangeRadio}>
                      <DndProvider backend={HTML5Backend}>
                        <Upload
                          beforeUpload={handleBeforeUpload}
                          className="upload2"
                          accept="image/png, image/jpeg, image/jpg"
                          action={uploadImage}
                          // customRequest={({ file }) => uploadImage(file)} 
                          fileList={photos.length ? fileList2 : fileList}
                          listType="picture-card"
                          onChange={onChange}
                          onPreview={onPreview}
                          onRemove={onRemove}
                          itemRender={(originNode, file, currFileList) => {
                            return (
                              <DragableUploadListItem
                                originNode={
                                  <div>
                                    {originNode}
                                    <div className="radioStyle">
                                      <Radio.Group
                                        onChange={onChangeRadio}
                                        name="radiogroup"
                                      >
                                        <Radio className="radio" value={file}>
                                        Make Primary?
                                        </Radio>
                                      </Radio.Group>
                                    </div>
                                  </div>
                                }
                                file={file}
                                fileList={currFileList}
                                moveRow={moveRow}
                              />
                            );
                          }}
                        >
                         {windowDimensions.width < 769 ? (
  <div style={{width:'100px'}}
  >
   
      <Uploadbanner />
   
  </div>
)  : (
                            <div
                              className={
                                fileList2?.length == 0
                                  ? "noPhotoButton"
                                  : "marq-wb"
                              }
                              style={{
                                marginTop: fileList2?.length == 0 ? "10vh" : "10vh"
                              }}
                            >
                              <div 
                               >
                              <Uploadbanner />
                              </div>
                              
                            </div>
                          )}
                        </Upload>
                      </DndProvider>
                    </Radio.Group>
                  </div>
                </Col>
              )}
            </div>
          </div>
        </div>
      </Col>
    </div>
  );
};

export default MarqueeAlbum;